define(["require", "exports", "tslib", "./DirectiveWaterMarkCore"], function (require, exports, tslib_1, DirectiveWaterMarkCore_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = {
        update: function (el, binding) {
            var value = binding.value;
            if (value) {
                if (typeof value === 'object') {
                    if (typeof value.show === 'undefined' || value.show) {
                        canvasWM((0, tslib_1.__assign)({ container: el }, value));
                    }
                    else {
                        canvasWM((0, tslib_1.__assign)((0, tslib_1.__assign)({ container: el }, value), { clear: true }));
                    }
                }
            }
            else {
                canvasWM();
            }
        }
    };
    var wmMutationObserverMap = new Map();
    var wmContentMap = new Map();
    var paramsMap = new Map();
    function clearWM(el) {
        var wms = el.querySelectorAll('.watermarker');
        wms.forEach(function (wm) { return wm.remove(); });
    }
    function fillTextCenter(ctx, text, x, y, width, height) {
        ctx.textBaseline = 'middle';
        ctx.textAlign = 'center';
        var lines = text.match(/[^\r\n]+/g);
        for (var i = 0; i < lines.length; i++) {
            var xL = (width - x) / 2;
            var yL = y + (height / (lines.length + 1)) * (i + 1);
            ctx.fillText(lines[i], xL, yL);
        }
    }
    function canvasWM(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.container, container = _c === void 0 ? document.body : _c, _d = _b.width, width = _d === void 0 ? '300px' : _d, _e = _b.height, height = _e === void 0 ? '300px' : _e, _f = _b.font, font = _f === void 0 ? '24px Microsoft Yahei' : _f, _g = _b.fillStyle, fillStyle = _g === void 0 ? '#ffffff' : _g, _h = _b.content, content = _h === void 0 ? '' : _h, _j = _b.rotate, rotate = _j === void 0 ? -30 : _j, _k = _b.show, show = _k === void 0 ? true : _k, _l = _b.clear, clear = _l === void 0 ? false : _l;
        var id = container.id;
        if (!id) {
            id = "wm_".concat(new Date().getTime());
            container.setAttribute('id', id);
        }
        paramsMap.set(id, show);
        wmContentMap.set(id, content);
        var observer = wmMutationObserverMap.get(id);
        var styleStr = null;
        if (clear) {
            clearWM(container);
            return;
        }
        var createWM = function () {
            var canvas = document.createElement('canvas');
            canvas.setAttribute('width', width);
            canvas.setAttribute('height', height);
            var ctx = canvas.getContext('2d');
            ctx.fillStyle = fillStyle;
            ctx.rotate((rotate * Math.PI) / 180);
            var contentObj = content || wmContentMap.get(id);
            console.log('base64Url', width, height);
            (0, DirectiveWaterMarkCore_1.drawText)(ctx, contentObj, {
                x: 0,
                y: 0,
                width: width.replace('px', '') / 2,
                height: height.replace('px', '') * 2,
                fontSize: font.split('px')[0]
            });
            var base64Url = canvas.toDataURL();
            var wm = container.querySelector('.watermarker');
            var watermarkDiv = wm || document.createElement('div');
            styleStr = "\n        position:absolute;\n        top:0;\n        left:0;\n        bottom:0;\n        right:0;\n        width:100%;\n        height:100%;\n        color:rgba(0,0,0,.75);\n        z-index:2000;\n        pointer-events:none;\n        background-repeat:repeat;\n        background-image:url('".concat(base64Url, "')");
            watermarkDiv.setAttribute('style', styleStr);
            watermarkDiv.classList.add('watermarker');
            if (!wm) {
                container.insertBefore(watermarkDiv, container.firstChild);
            }
        };
        if (!observer) {
            observer = new MutationObserver(function (mutationList) {
                var showWM = paramsMap.get(id);
                var wmInstance = container.querySelector('.watermarker');
                if (!wmInstance && showWM) {
                    console.log('水印被删除了！！！');
                    createWM();
                    return;
                }
                if ((wmInstance === null || wmInstance === void 0 ? void 0 : wmInstance.getAttribute('style')) !== styleStr && showWM) {
                    console.log('改水印样式了！！！');
                    createWM();
                    return;
                }
            });
            observer.observe(container, {
                childList: true,
                attributes: true,
                subtree: true
            });
            wmMutationObserverMap.set(id, observer);
        }
        createWM();
    }
});
//# sourceMappingURL=DirectiveWaterMarker.js.map